import React, { useState, useEffect } from "react"
import { GalleryVerticalEnd } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Link, useNavigate } from "react-router-dom"
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert"
import { useDispatch, useSelector } from "react-redux";
import { loginServiceRequest } from "@/services/auth/services";

export default function Login() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  
  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      navigate("/");
    }
  }, [navigate]);

  // Giriş başarılıysa yönlendirme için (örnek: error yok ve loading false ise)
  useEffect(() => {
    if (submitted && !loading && !error) {
      setTimeout(() => navigate("/"), 1000);
    }
  }, [submitted, loading, error, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginServiceRequest({
      email: email,
      password: password,
    }));
    setSubmitted(true);
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
      <div className="flex flex-col gap-4 p-6 lg:px-10 justify-center items-center">
        <div className="flex justify-center gap-2 mb-6">
          <a href="#" className="flex items-center gap-2 font-medium">
            <div className="flex h-6 w-6 justify-center items-center rounded bg-primary text-primary-foreground">
              <GalleryVerticalEnd className="size-4" />
            </div>
            sMPC
          </a>
        </div>

        <div className="w-full max-w-md px-6 py-6">
          <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
            <div className="flex flex-col items-center gap-2 text-center">
              <h1 className="text-2xl font-bold">Giriş Yap</h1>
            </div>

            <div className="grid gap-6">
              <div className="grid gap-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="m@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="grid gap-2">
                <div className="flex items-center">
                  <Label htmlFor="password">Parola</Label>
                  <Link to="/resetpassword" className="ml-auto text-sm underline-offset-4 hover:underline">
                    Parolanızı mı unuttunuz?
                  </Link>
                </div>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <Button type="submit" variant="default" className="w-full" disabled={loading}>
                {loading ? "Giriş Yapılıyor..." : "Giriş Yap"}
              </Button>

              {submitted && !loading && !error && (
                <Alert variant="success">
                  <AlertTitle>Başarılı</AlertTitle>
                  <AlertDescription>Giriş başarılı! 2FA ekranına yönlendiriliyorsunuz...</AlertDescription>
                </Alert>
              )}
              {submitted && !loading && error && (
                <Alert variant="warning">
                  <AlertTitle>Uyarı!</AlertTitle>
                  <AlertDescription>Geçersiz email veya parola.</AlertDescription>
                </Alert>
              )}
            </div>

            <div className="text-center text-sm">
              Hesabınız yok mu?{" "}
              <Link to="/signup" className="underline underline-offset-4">
                Kayıt Ol
              </Link>
            </div>
          </form>
        </div>
      </div>

      <div className="hidden lg:flex w-full h-screen">
        <img src="/cat.png" alt="Image" className="w-full h-full object-cover" />
      </div>
    </div>
  )
}
